/* eslint-disable react/no-danger */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { formatPrice } from 'utils/products';
import placeholderImage from 'assets/img/rambla-icon.png';
import * as Ui from './SelectedProduct.styles';

const SelectedProduct = ({ product, onRemove }) => {
  const childProduct = product.child_product ?? product;
  const { picture, product_code, price, currency } = childProduct;
  const [maskVisible, setMaskVisibility] = useState(false);
  const { t } = useTranslation('ownerPortal');
  const formattedPrice = price !== undefined && currency ? formatPrice(price, currency) : null;
  const imageSrc = picture || placeholderImage;
  const isPlaceholder = !picture;
  const productCode = product_code || '-';

  return (
    <Ui.Container
      onMouseEnter={() => setMaskVisibility(true)}
      onMouseLeave={() => setMaskVisibility(false)}
    >
      <Ui.ImageWrapper>
        <Ui.Image alt="product" src={imageSrc} $isPlaceholder={isPlaceholder} />
      </Ui.ImageWrapper>
      <div className="data">
        <p className="name">{productCode.toUpperCase()}</p>
        {formattedPrice ? <p>{formattedPrice}</p> : null}
      </div>
      {maskVisible && (
        <Ui.Mask onClick={onRemove}>
          <p>{t('app:remove')}</p>
        </Ui.Mask>
      )}
    </Ui.Container>
  );
};

SelectedProduct.propTypes = {
  product: PropTypes.shape({
    uid: PropTypes.string.isRequired,
    child_product: PropTypes.shape({
      uid: PropTypes.string,
      picture: PropTypes.string,
      product_code: PropTypes.string,
      price: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      currency: PropTypes.string,
    }),
    picture: PropTypes.string,
    product_code: PropTypes.string,
    price: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    currency: PropTypes.string,
  }).isRequired,
  onRemove: PropTypes.func,
};

export default SelectedProduct;
